import React from 'react';
import AnswerOptionIndex from './answerOptionIndex/answerOptionIndex';
import ResultIndex from './resultIndex/resultIndex';
import InlineWhisper from '../inlineWhisper/inlinewhisper';

import * as eventsApi from '../../api/eventsApi';
import tagular from '../../util/tagular';

import './poll.scss';

class Poll extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showResults: false,
            pollOptionIdSelected: null,
            voteRegistered: false
        }

        this.pollId = this.props.match.params.pollId;

        this.handleSelect = this.handleSelect.bind(this);
        this.handleResultsClick = this.handleResultsClick.bind(this);
        this.toggleDisplay = this.toggleDisplay.bind(this);
        this.determinePrivacyPolicy = this.determinePrivacyPolicy.bind(this);
    }

    componentDidMount() {
        this.props.fetchPoll(this.pollId);
        this.props.fetchVotes(this.pollId);
        this.props.fetchResults(this.pollId);
    }

    handleSelect(pollOptionId) {
        if (!this.state.voteRegistered) {
            this.props.registerVote(pollOptionId);
        }

        this.setState({
            showResults: true,
            pollOptionIdSelected: pollOptionId,
            voteRegistered: true,
        })
    }

    handleResultsClick(e) {
        this.setState({
            showResults: true
        })

        const { poll, inlineParentMetadata } = this.props;

        eventsApi.resultClicked(poll.question, poll, { inlineParentMetadata });

        tagular.sendElementClickedEvent(e, { 
            position: 'Article Body', 
            location: 'CARDS', 
            text: `Poll Results_${poll.name}`,
            name: 'Inline Poll',
            action: 'OPEN',
        });
    }

    toggleDisplay() {
        return this.state.showResults ? 'hide' : 'show';
    }

    determinePrivacyPolicy() {
        const { poll } = this.props;
        if (!poll) return '';

        const linkMapping = {
            hl: 'https://www.healthline.com/privacy-policy',
            mnt: 'https://www.healthline.com/privacy-policy',
            gr8: 'https://greatist.com/privacy-policy'
        };

        let link = linkMapping.hl;

        if (linkMapping[poll.site]) {
            link = linkMapping[poll.site];
        }

        return link;
    }

    render() {
        const {
            poll,
            pollVotes,
            pollResults,
            inlineParentMetadata,
            appType
        } = this.props;

        return (
            <div className={`poll ${poll.site}`}>
                <InlineWhisper isInline={true} whisper={poll.whisper} site={poll.site}/>

                <h3 className='question'>{poll.question}</h3>

                <div className='description'>{poll.description}</div>

                <AnswerOptionIndex 
                    handleSelect={this.handleSelect} 
                    options={poll.pollOptions} 
                    pollVotes={pollVotes} 
                    showResults={this.state.showResults}
                    pollInfo={poll}
                    inlineParentMetadata={inlineParentMetadata}
                    appType={appType}
                />

                <ResultIndex
                    showResults={this.state.showResults}
                    options={poll.pollOptions}
                    pollOptionId={this.state.pollOptionIdSelected}
                    pollResults={pollResults}
                    pollInfo={poll}
                    inlineParentMetadata={inlineParentMetadata}
                />

                <div className='links'>
                    <a className='footer-link' href={this.determinePrivacyPolicy()} target='_blank'>Privacy policy</a>
                    <span className='footer-link' onClick={(e) => this.handleResultsClick(e)} id={this.toggleDisplay()}>Poll results</span>
                </div>
            </div>
        )
    }

}


export default Poll;